/** The one winner function. No game branches, by design. */
export function currentWinner(trick, ctx) {
    if (trick.plays.length === 0)
        return null;
    const trumps = trick.plays.filter((p) => ctx.isTrump(p.card));
    const pool = trumps.length > 0
        ? trumps
        : trick.plays.filter((p) => ctx.effectiveSuit(p.card) === trick.ledSuit);
    // A trick where nobody followed and nothing is trump cannot happen while the
    // leader's own card always matches its own effective suit, but guard anyway.
    if (pool.length === 0)
        return trick.plays[0];
    return pool.reduce((best, p) => (ctx.strength(p.card) > ctx.strength(best.card) ? p : best));
}
/** Highest card of a set under this context. Convenience for bots. */
export function strongest(cards, ctx) {
    if (cards.length === 0)
        return null;
    return cards.reduce((a, b) => (ctx.strength(b) > ctx.strength(a) ? b : a));
}
export function weakest(cards, ctx) {
    if (cards.length === 0)
        return null;
    return cards.reduce((a, b) => (ctx.strength(b) < ctx.strength(a) ? b : a));
}
//# sourceMappingURL=ranking.js.map